// extracted by mini-css-extract-plugin
module.exports = {"title":"executor-poll_title__e5RaP","tab-list":"executor-poll_tab-list__1YKZp","tab":"executor-poll_tab__nsUEP","tab--selected":"executor-poll_tab--selected__2lPni"};